import React from 'react';
import { ReactComponent as OmaniRialGlyph } from '../assets/omani-rial.svg';

/**
 * The Omani Rial currency mark, rendered from the official symbol artwork
 * rather than the Unicode OMANI RIAL SIGN (U+20C4) -- no shipped font
 * renders that code point, so plain text falls back to a missing-glyph box.
 * Sized in `em` so it scales with the surrounding text and inherits color
 * via `currentColor`.
 */
export default function RialSymbol({
  style,
  className,
}: {
  style?: React.CSSProperties;
  className?: string;
}) {
  return (
    <OmaniRialGlyph
      aria-label="OMR"
      role="img"
      className={className}
      style={{
        width: '0.85em',
        height: '0.85em',
        verticalAlign: '-0.05em',
        fill: 'currentColor',
        flexShrink: 0,
        ...style,
      }}
    />
  );
}
